var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOlhofechado({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2552 20L6.25522 5M11.0552 10.9416C10.6818 11.3533 10.4552 11.894 10.4552 12.4863C10.4552 13.7761 11.5297 14.8217 12.8552 14.8217C13.4664 14.8217 14.0242 14.5994 14.4479 14.2334M21.294 14.8217C22.1202 13.5848 22.4552 12.5761 22.4552 12.5761C22.4552 12.5761 20.2706 5.6 12.8552 5.6C12.4389 5.6 12.0391 5.62199 11.6552 5.66349M18.2552 17.8494C16.8778 18.7281 15.1045 19.3495 12.8552 19.3127C5.53214 19.193 3.25522 12.5761 3.25522 12.5761C3.25522 12.5761 4.31307 9.19808 7.45522 7.14332",
    stroke: "#265daf",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOlhofechado);
export default __webpack_public_path__ + "static/media/olhofechado.820b3120161ab38c6f2791b79927c7a5.svg";
export { ForwardRef as ReactComponent };